import { render, staticRenderFns } from "./CountryRegistrationReport.container.vue?vue&type=template&id=2be1984a&scoped=true&"
import script from "./CountryRegistrationReport.container.vue?vue&type=script&lang=js&"
export * from "./CountryRegistrationReport.container.vue?vue&type=script&lang=js&"
import style0 from "./CountryRegistrationReport.container.vue?vue&type=style&index=0&id=2be1984a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be1984a",
  null
  
)

export default component.exports